/**
 * Utility functions for EditQueryModal component
 */

/**
 * Normalizes lifecycle status value
 * @param {string|number} value - The status value to normalize
 * @returns {string} Normalized status value
 */
export const normalizeLifecycleValue = (value) => {
  if (!value && value !== 0) return '';
  const normalized = value.toString().trim().toLowerCase();
  if (!normalized) return '';
  return normalized === 'open' ? 'raised' : normalized;
};

/**
 * Filters out "test description" from query description
 * @param {string} queryDesc - Query description to filter
 * @returns {string} Filtered query description
 */
export const filterTestDescription = (queryDesc) => {
  const desc = queryDesc || '';
  return desc.toLowerCase().trim() === 'test description' ? '' : desc;
};

/**
 * Prepares status label for storage
 * @param {string} statusLabel - Current status label
 * @returns {string} Status label formatted for storage
 */
export const prepareStatusLabelForStorage = (statusLabel) => {
  const normalized = normalizeLifecycleValue(statusLabel || 'raised');
  return normalized === 'raised' ? 'open' : normalized;
};
